import {
  Input,
  Component,
  forwardRef,
  OnInit,
  Output,
  EventEmitter,
  ViewChild,
  SimpleChanges,
  OnChanges,
  AfterViewInit,
  Renderer2,
  ElementRef
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, AbstractControl } from '@angular/forms';
import { NgbTooltipConfig } from '@ng-bootstrap/ng-bootstrap';
import { Subscription, Subject, Observable, Observer, merge } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { NgbTypeahead } from '@ng-bootstrap/ng-bootstrap';
import { debounceTime, distinctUntilChanged, filter, map } from 'rxjs/operators';
import { UtilityCommon } from "../../../utils/utility-common";
import { OrderByPipe } from "../../../pipes/order-by.pipe";

declare var $: any;

export const COMBO_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => ComboModComponent),
  multi: true
};

@Component({
  selector: '[comboModInput]',
  templateUrl: 'comboMod.component.html',
  styleUrls: ['comboMod.component.css'],
  providers: [COMBO_VALUE_ACCESSOR, NgbTooltipConfig, OrderByPipe]
})

export class ComboModComponent implements ControlValueAccessor, OnInit, OnChanges, AfterViewInit  {

  @Input() labelInput: string;
  @Input() optionsCombo: Array<any> = [];
  @Input() control: AbstractControl;
  @Input() labelOption: string = 'label';
  @Input() labelOptionSeparator: string;
  @Input() location: string;
  @Input() submitPending: boolean;
  @Input() disabledSelect: boolean = false;
  @Input() noOrder: boolean;
  @Input() objectReference: any = null;
  @Input() mandatory: any;
  @Input() valueOption: string = 'id';
  @Input() disabledCheck: boolean;
  @Input() disabledCheckProperty: string;
  @Input() orderList: boolean = true;
  @Input() orderListType: string = 'ASC';
  @Input() viewRimossi: boolean = false;
  @Input() valueRimosso: string = 'rimosso';
  @Input() labelNoSelection: string;
  @Input() isSearchRequest: boolean;
  @Input() noDefaultOption: boolean = false;
  @Output() onReturn = new EventEmitter();
  @Input() autocomplete: boolean = false
  @ViewChild('instance') instance: NgbTypeahead;
  @Output() recordToAdd = new EventEmitter();
  focus$ = new Subject<string>();
  click$ = new Subject<string>();
  txt: string;
  @Input() info: string;
  @Input() highlight: boolean = false;
  @Input() highlightLabel: string = null;

  private internalObject: any;
  private _value: string;
  public enableObservable: Observable<boolean>;
  private subscription: Subscription = null;
  private enableObserver: Observer<boolean>; private onTouchedCallback: () => void = () => { };
  private onChangeCallback: (_: any) => void = () => { };
  randomId: string = this.getRandomId();

  constructor(private httpService: HttpClient, private orderBy: OrderByPipe, private el: ElementRef, private renderer: Renderer2) {
  }

  ngAfterViewInit(): void { 
    // Seleziona tutti gli input nel componente
    const inputs = this.el.nativeElement.querySelectorAll('input');
    inputs.forEach((input: HTMLInputElement) => {
      // Rimuovi l'attributo aria-multiline
      if (input.hasAttribute('aria-multiline')) {
        this.renderer.removeAttribute(input, 'aria-multiline');
      }
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.isSearchRequest && this.objectReference) {
      if (this.objectReference !== null) {
        this.internalObject = (this.objectReference.value !== null) ? { id: this.objectReference.value } : { id: '-1' };
      }
    }
    if (!this.isSearchRequest) {
      this.internalObject = this.objectReference ? JSON.parse(JSON.stringify(this.objectReference)) : { id: '-1' };
    }
  }

  ngOnInit(): void {
    if (!this.submitPending) {
      this.createServiceSubscription();
    }
    if (!this.valueOption) {
      this.valueOption = 'id';
    }
    if (this.isSearchRequest) {
      if (this.objectReference !== null) {
        this.internalObject = (this.objectReference.value !== null) ? { id: this.objectReference.value } : { id: '-1' };
      } else {
        this.internalObject = { id: '-1' };
      }
    }
    if (!this.labelNoSelection) {
      this.labelNoSelection = 'Scegli ' + this.labelInput;
    }
  }

  private createServiceSubscription() {
    this.enableObservable = new Observable<boolean>(observer => {
      this.enableObserver = observer;
      if (this.enableObserver) {
        this.submitPending = true;
      } else {
        this.submitPending = false;
      }
    });
  }

  onChange(): any {
    this.txt = null;
    if (this.internalObject.id === '-1') {
      this.onReturn.emit(null);
    } else {
      let returnedElement = this.internalObject;
      for (let elemento of this.optionsCombo) {
        if (elemento && elemento.id && elemento.id === returnedElement.id) {
          returnedElement = elemento;
        }
      }
      this.onReturn.emit(JSON.parse(JSON.stringify(returnedElement)));
    }
  }

  onChangeInput(event: KeyboardEvent) {
    let newValue = (<HTMLInputElement>event.target).value;
    if (newValue == '') {
      this.internalObject = { id: '-1' };
      this.onChange();
    }
  }

  getLabelOption(objectList: any, attrValue: string): string {
    let element: any = '';
    if (attrValue.indexOf('.') > 0) {
      if (attrValue.indexOf('+') > 0) { // pi� di un campo annidato es. parte.nome+parte.cognome
        let objTemp = objectList;
        let elementsArray = attrValue.split('+');
        for (let entryEl of elementsArray) {
          let someArray = entryEl.split('.');
          for (let entryAt of someArray) {
            if (objTemp) {
              objTemp = objTemp[entryAt];
            }
          }
          if (objTemp) {
            element = element + this.labelOptionSeparator + objTemp; // uso separatore di input per separare i valori es. label+codice sep=" - "; diventa ROMA - 00100
          }
          objTemp = objectList;
        }
      } else {  // un solo campo annidato es. parte.nome
        let objTemp = objectList;
        let someArray = attrValue.split('.');
        for (let entryAt of someArray) {
          if (objTemp) {
            objTemp = objTemp[entryAt];
          }
        }
        if (objTemp) {
          element = objTemp;
        }
      }
    } else { // un solo campo non annidato es. descrizione oppure label
      if(attrValue.includes('+')){ //se ho più label non annidate (DA MIGLIORARE)
        let label = '';
        let arrayAttributi = attrValue.split('+');
          arrayAttributi.forEach(el => {
            label = label.length === 0  ? ((objectList[el] ? objectList[el] : '')) : label + (objectList[el] ? this.labelOptionSeparator + objectList[el] : '');
          })
          element = label;
        }else {
          element = objectList[attrValue];

        }
      }
    return element;
  }

  /*  terribile! viene chiamata ogni secondo
  ngDoCheck(): void {
    if (this.optionsCombo && this.optionsCombo.length > 0) {
      this.gestRimossi();
    }
  }
  private gestRimossi() { // Metodo per togliere i valori disattivati. Se il valore passato in ingresso � disattivato non lo toglie dalla lista
    if (!this.viewRimossi &&
        this.optionsCombo &&
        this.optionsCombo.length > 0 &&
        this.optionsCombo[0][this.valueOption] &&
        (this.optionsCombo[0][this.valueRimosso] || !this.optionsCombo[0][this.valueRimosso]) &&
        (this.optionsCombo.findIndex( f => f[this.valueRimosso] === true) >= 0)
        ) {
      let idDefault = '';
      if (this.objectReference && this.objectReference[this.valueOption]) {
        idDefault = this.objectReference[this.valueOption];
      }
      this.optionsCombo = this.optionsCombo.filter(o => o[this.valueRimosso] === false || o[this.valueOption] === idDefault);
    }
  }
*/
  writeValue(value: any): void {
    this._value = value;
  }

  registerOnChange(fn: any): void {
    this.onChangeCallback = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouchedCallback = fn;
  }

  getClass() {
    return this.labelInput ? UtilityCommon.sanitizeString(this.labelInput).toLowerCase() + '-select-class' : 'select-generic-class';
  }

  getHighlight() {
    return this.highlight ? 'highlight-border-input' : '';
  }

  search = (text$: Observable<string>) =>
    merge(text$.pipe(debounceTime(200), distinctUntilChanged()),
      this.click$.pipe(filter(() => !this.instance.isPopupOpen())),
      this.focus$).pipe(
        debounceTime(200),
        map(term => term === '' ? this.orderBy.transform(this.optionsCombo, this.labelOption + ':' + this.orderListType)
          : this.orderBy.transform(this.optionsCombo.filter(v => v.label.toLowerCase().indexOf(term.toLowerCase()) > -1), this.labelOption + ':' + this.orderListType))
      )
  formatter = (result: any) => this.getLabelOption(result, this.labelOption);
  onSelectItem(evt) {
    this.internalObject = evt.item;
    this.onChange();
  }
  clearValue(){
    if(!this.objectReference || this.objectReference.id === '-1'){
      const typeahead = <HTMLInputElement>document.getElementById('typeahead-template');
      typeahead.value = '';
    }
  }

  addRecord(){
    this.instance.writeValue(null);
    this.recordToAdd.emit(this.txt);
    this.txt = null;
  }

  getRandomId(length: number = 10): string {
    return crypto.randomUUID();
  }

  setDisabledState(isDisabled: boolean): void {
    this.submitPending = isDisabled;
  }

}
